import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import { Calendar, ExternalLink } from "lucide-react";

export default function News() {
  const [news, setNews] = useState([]);
  useEffect(() => { api.get("/news").then(({ data }) => setNews(data)).catch(() => {}); }, []);

  return (
    <>
      <SEO title="Cochlear Implant News & Research from India and the World" description="Latest CI news, technology updates, government scheme announcements, and research summaries — curated by HearClear." />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">News & Research</h1>
          <p className="mt-5 text-slate-700 text-[1.05rem]">Curated updates on cochlear implant technology, India CI news, government schemes, CSR and research.</p>
        </div>
      </section>

      <section className="hc-container py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {news.map((n) => (
          <Link key={n.id} to={`/news/${n.slug}`} data-testid={`news-${n.slug}`} className="card-hc block">
            {n.image && <img src={n.image} alt={n.title} className="rounded-xl w-full aspect-[16/9] object-cover" />}
            <div className="mt-4 text-[12px] text-[#0F766E] font-semibold uppercase tracking-wider flex items-center gap-1.5">
              <Calendar size={13} /> {n.category} · {n.published_at?.slice(0, 10)}
            </div>
            <div className="mt-2 font-serif text-lg font-semibold text-slate-900 leading-snug">{n.title}</div>
            <p className="mt-2 text-slate-600 text-[14.5px] leading-relaxed line-clamp-3">{n.summary}</p>
            <div className="mt-3 text-[13px] text-slate-500 flex items-center gap-1"><ExternalLink size={12} /> {n.source}</div>
          </Link>
        ))}
      </section>
    </>
  );
}
